import { useMsal } from '@azure/msal-react';
import { useEffect, useRef } from 'react';

const InactivityLogout = () => {
    const { instance } = useMsal();
    const inactivityTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
    const INACTIVITY_TIMEOUT_MS = 8 * 60 * 60 * 1000; // 8 hours

    const resetInactivityTimer = () => {
        if (inactivityTimer.current) {
            clearTimeout(inactivityTimer.current);
        }
        inactivityTimer.current = setTimeout(() => {
            // Perform MSAL logout
            instance.logoutRedirect({
                postLogoutRedirectUri: `${window.location.origin}/signed-out`,
            });
        }, INACTIVITY_TIMEOUT_MS);
    };

    useEffect(() => {
        // Initialize the timer on component mount
        resetInactivityTimer();

        // Add event listeners to detect activity
        const activityEvents = ['mousemove', 'keydown', 'click', 'scroll'];
        activityEvents.forEach(event => {
            window.addEventListener(event, resetInactivityTimer);
        });

        // Clean up event listeners and timer on component unmount
        return () => {
            activityEvents.forEach(event => {
                window.removeEventListener(event, resetInactivityTimer);
            });
            if (inactivityTimer.current) {
                clearTimeout(inactivityTimer.current);
            }
        };
    }, [instance]);

    return null;
};

export default InactivityLogout;